<template>
  <div>
  <el-card class="box-card" v-show="dialogVisible" :style="{'top':marginTopLen,'left':marginLeftLen}">
<!--    <template #header>-->
      <div class="card-header">
        <div style="display: flex;width: 100%">
          <img :src="imgpath" style="width: 45px;height: 62px;margin: 0.5% 2%;" />
          <div class="header_word">{{title}}</div>
        </div>

        <el-button class="el-icon-close" style="color: #b2eeff;margin-right: 1%;margin-top: -2%;font-size: 22px;"  type="text" @click="cancel"></el-button>
      </div>
<!--    </template>-->
    <div style="padding: 20px;background-color: rgba(247,246,246,0.1);">
      <el-row >
        <el-col :span="14">
          <div >
            <el-card style="background-color: rgba(247, 246, 246, 0.1);">
              <div style="height: 635px;overflow-x: hidden;overflow-y: auto" id="infoDiv">
<!--                <el-scrollbar  style="height: 100%" >-->
                <div  v-for="(value, i) in QAList" :key= i :class="[value.isQa?'questiondiv':'answerdiv']">
                  <div :class="[value.isQa?'questionicon':'answericon']"> </div>
                  <div  :class="[value.isQa?'questionlabel':' answerlabel']"  >
                    <div :class="[value.isQa?'qulabelword':' anlabelword']">
                      <div  v-html="value.content"></div>
                      <div v-if="value.content !== errorWord">
                        <div v-if="!value.isQa && i!== 0 &&value.content!==defualWord"  :class="{parentdiv:praiseIndex.indexOf(i) >-1||slanderIndex.indexOf(i) >-1 }" style="display: flex;vertical-align: middle;padding-right: 10px;padding-top: 5px">
                          <div :id="'praise'+i" style="margin-left: auto;display: flex;vertical-align: middle;cursor:pointer" @click="praise(value,i)">
                            <div  :class="[praiseIndex.indexOf(i) >-1?'pitpraisediv':'praisediv']" ></div>
                            <div  style="font-size: 13px;line-height: 15px;vertical-align: middle;">满意</div>
                          </div>

                          <div :id="'slander'+i" style="padding-left: 10px;display: flex;vertical-align: middle;cursor:pointer" @click="slander(value,i)">
                            <div  :class="[slanderIndex.indexOf(i) >-1?'pitslanderdiv':'slanderdiv']" ></div>
                            <div  style="font-size: 13px;line-height: 15px;vertical-align: middle;">不满意</div>
                          </div>
                        </div>
                      </div>
                      <div v-if="value.recommended.length >0"  >
                        <div style="margin-top:2%;margin-bottom:2%;color: #333333;font-family: MicrosoftYaHei;font-size: 18px;font-weight: bold;font-stretch: normal;">关联问题推荐：</div>
                        <div  v-for="(simialrvalue, j) in value.recommended"  style="display: flex;">
                              <el-row>
                                <el-col :span="1">
                                  <div style="width: 5px;height: 5px;background-color: #72ca8d;margin:1%;border-radius: 50%;position: relative;top: 6px"></div>
                                </el-col>
                                <el-col :span="23">
                                  <div style="text-align: left;width: 550px;display: inline-block">
                                    <el-link class="link-title" :underline="false"  @click="querybyQA(simialrvalue.question)" :title="simialrvalue.question">{{simialrvalue.question}}</el-link>
                                  </div>
                                </el-col>
                              </el-row>
<!--                          <div style="width: 5px;height: 5px;background-color: #72ca8d;margin:2%;border-radius: 50%;"></div>-->
<!--                          <el-link :underline="false" class="link-title" @click="querybyQA(simialrvalue.question)" :title="simialrvalue.question">{{simialrvalue.question}}</el-link>-->

                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <div style="padding-bottom: 10px;padding-top: 5px">
                <el-row :gutter="20" >
                  <el-col :span="20" >
                    <el-autocomplete class="inline-input" v-model="question" style="width: 100%;margin-left: 2%;"
                                     @keyup.enter.native="queryAnswerEntery"
                                     :debounce=0
                                     :popper-class="classname"
                                     :fetch-suggestions="querySearch" placeholder="请输入您想咨询的问题..."
                                     @select="handleSelect"  :trigger-on-focus="false"
                    >

                    </el-autocomplete>

                    <!--                       <el-input   v-model="question"  maxlength="1000" style="margin-left: 1%;" placeholder="请输入您想咨询的问题..."    @keyup.enter.native="queryAnswer" ></el-input>-->
                  </el-col>
                  <el-col :span="2">
                    <el-button type="primary" class="el-icon-s-promotion" @click="queryAnswer">发送</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="10">
          <div>
              <div><span class="title_word">热点问题：</span></div>
              <div style="float: left;margin-top: 20px">
<!--                    <div v-for="item in  hotquestions" :key="item"   style="margin-top:1%;margin-left: 2%"  >-->
<!--                      <div style="display: flex;">-->
<!--                        <div style="width: 5px;height: 5px;background-color: #72ca8d;margin:1%;border-radius: 50%;"></div>-->
<!--                        <div style="text-align: left;width: 600px">-->
<!--                          <el-link class="link-title" :underline="false"  @click="querybyQA(item)" :title="item">{{item}}</el-link>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                        <div v-for="item in  hotquestions" :key="item"   style="margin-top:1%;margin-left: 2%"  >
                          <el-row>
                            <el-col :span="1">
                              <div style="width: 5px;height: 5px;background-color: #72ca8d;margin:1%;border-radius: 50%;position: relative;top: 6px"></div>
                            </el-col>
                            <el-col :span="23">
                              <div style="text-align: left;width: 500px;display: inline-block">
                                <el-link class="link-title" :underline="false"  @click="querybyQA(item)" :title="item">{{item}}</el-link>
                              </div>
                            </el-col>
                          </el-row>
                        </div>

              </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </el-card>
  </div>
</template>
<script>
import { get, getQAList, addQA} from '@/api/common'

export default {
  name: 'qadialog',
  filters: {
    // ellipsis (value) {
    //   if (!value) return ''
    //   if (value.length > 30) {
    //     return value.slice(0, 30) + '...'
    //   }
    //   return value
    // }
  },
  data () {
    return {
      siteId: '',
      dialogVisible: true,
      question: '',
      praiseIndex: [],
      slanderIndex: [],
      defalutIndex: [],
      title: '',
      imgpath: '',
      hotquestions: [],
      classname: 'cname',
      defualWord: '这个问题我还不会',
      dataList: [],
      errorWord: '网络异常,请稍后再试',
      iframeWin: null,
      result: {
        isQa: false,
        content: '这个问题我还不会',
        recommended: []
      },
      welcome: {
        isQa: false,
        content: 'Hi，您好，我是林芝市智能问答服务机器人,您可以输入问题向我提问',
        recommended: []
      },
      QAList: [
      ],
      marginTopLen: '0px',
      marginLeftLen: '0px'

    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
        this.$router.push({
          path: '/qadialog'
        })
      }
    }
  },
  created () {
  },
  mounted: function () {
    this.adoptScrenn()
    let siteCode = this.$route.query.code
    console.info('对接传过来的code', siteCode)
    let obj = {
      code: siteCode
    }
    get('site/getSiteByCode', obj).then((resp) => {
      if (resp.data.code === 0) {
        if (resp.data.data != null) {
          this.siteId = resp.data.data.id
          let params = {
            pageSize: 10,
            pageNow: 0,
            isHotQuestion: 'true',
            siteId: this.siteId
          }
          this.init(params)
          this.initConfig()
          let that = this
          window.addEventListener(
            'message',
            function (event) {
              if (event.data != null && event.data !== undefined) {
                if (typeof event.data === 'boolean') {
                  that.dialogVisible = event.data
                }
              }
            },
            false
          )
          window.addEventListener('resize', () => {
            this.adoptScrenn()
          })
        } else {
          this.$notify({
            title: '提示',
            message: '查无此站点信息',
            type: 'warning'
          })
        }
      } else {
        this.$notify({
          title: '提示',
          message: '获取站点数据异常',
          type: 'warning'
        })
        return false
      }
    })
    console.info('siteId', this.siteId)
  },
  methods: {
    adoptScrenn () {
      let clientHeight = document.documentElement.clientHeight
      let clientWidth = document.documentElement.clientWidth
      if (clientHeight > 800) {
        this.marginTopLen = (clientHeight - 800) / 2 + 'px'
      } else {
        this.marginTopLen = 0 + 'px'
      }
      if (clientWidth > 1190) {
        this.marginLeftLen = (clientWidth - 1190) / 2 + 'px'
      } else {
        this.marginLeftLen = 0 + 'px'
      }
    },
    initConfig () {
      let params = {
        col: this.siteId
      }

      getQAList('config/select', params).then((resp) => {
        if (resp.data.code === 0) {
          if (resp.data.data != null) {
            let result = resp.data.data.content
            let json = JSON.parse(result)
            this.imgpath = json.logoImgUrl
            this.title = json.title
            if (json.welcomeWord !== '') {
              this.welcome.content = json.welcomeWord
            }
            this.QAList.push(this.welcome)
            if (json.defualWord !== '') {
              this.result.content = json.defualWord
              this.defualWord = json.defualWord
            }
          } else {
            this.QAList.push(this.welcome)
          }
        } else {
          this.$notify({
            title: '提示',
            message: '获取系统配置数据失败，网络异常',
            type: 'warning'
          })
          return false
        }
      })
    },
    init (params) {
      let url = '/getOnlyAnswerList'
      get(url, params).then(response => {
        if (response.data.ret === 1) {
          this.hotquestions = response.data.content.questionList
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '获取热点问题异常',
          type: 'warning'
        })
      })
    },
    praise (item, i) {
      let arrIndex = this.praiseIndex.indexOf(i)
      if (arrIndex < 0) {
        this.praiseIndex.push(i)
        let url = '/totalPraise'
        let params = {
          quesId: item.questionId
        }
        get(url, params).then(response => {
          if (response.data.code === 0) {
            this.$notify({
              title: '提示',
              message: response.data.data,
              type: 'success'
            })
          }
        }).catch(response => {
          this.totalPageNum = 0
          this.$notify({
            title: '提示',
            message: response.data.data,
            type: 'warning'
          })
        })
      }
    },
    slander (item, i) {
      let arrIndex = this.slanderIndex.indexOf(i)
      if (arrIndex < 0) {
        this.slanderIndex.push(i)
        let url = '/totalSlander'
        let params = {
          quesId: item.questionId
        }
        get(url, params).then(response => {
          if (response.data.code === 0) {
            this.$notify({
              title: '提示',
              message: response.data.data,
              type: 'success'
            })
          }
        }).catch(response => {
          this.totalPageNum = 0
          this.$notify({
            title: '提示',
            message: response.data.data,
            type: 'warning'
          })
        })
      }
    },
    cancel () {
      this.dialogVisible = false
    },
    querybysimialr (id) {

    },
    querySearch (queryString, cb) {
      // console.info(queryString)
      let params = {
        pageSize: 10,
        pageNow: 0,
        qaSelect: queryString,
        siteId: this.siteId
      }
      let url = '/getOnlyAnswerList'
      get(url, params).then(response => {
        if (response.data.ret === 1) {
          // this.hotquestions = response.data.content.questionList
          // 调用 callback 返回建议列表的数据
          let restaurants = response.data.content.mapList
          let $cname = document.querySelector('.' + this.classname)
          if (restaurants.length > 0) {
            $cname.style.display = 'block'
          } else {
            $cname.style.display = 'none'
          }

          cb(restaurants)
        }
      }).catch(response => {
        this.totalPageNum = 0
        // this.$notify({
        //   title: '提示',
        //   message: '网络异常，联想搜索无法查询',
        //   type: 'warning'
        // })
      })
      // cb(results)
    },
    querySimilar (queryString) {
      let params = {
        pageSize: 10,
        pageNow: 0,
        qaSelect: queryString,
        isHotQuestion: 'true'
      }
      this.init(params)
    },
    chatlog () {
      // console.log('chatlog change')
      this.$nextTick(() => {
        var container = this.$el.querySelector('#infoDiv')
        // console.log(container)
        container.scrollTop = container.scrollHeight
      })
    },

    queryAnswerEntery () {
      let $cname = document.querySelector('.' + this.classname)

      $cname.style.display = 'none'

      if (this.question === '') {
        return
      }
      let question = {
        isQa: true,
        content: this.question,
        recommended: []
      }
      let params = {question: this.question, siteId: this.siteId}
      this.QAList.push(question)
      this.getResquest(params)
    },

    queryAnswer (evt) {
      let target = evt.target
      // 根据button组件内容 里面包括一个span标签，如果设置icon，则还包括一个i标签，其他情况请自行观察。
      // 所以，在我们点击到button组件上的文字也就是span标签上时，直接执行e.target.blur()不会生效，所以要加一层判断。
      if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
        target = evt.target.parentNode
      }
      target.blur()
      if (this.question === '') {
        this.$notify({
          title: '提示',
          message: '请输入您想咨询的问题',
          type: 'warning'
        })
        return
      }
      let question = {
        isQa: true,
        content: this.question,
        recommended: []
      }
      let params = {question: this.question, siteId: this.siteId}
      this.QAList.push(question)
      this.getResquest(params)
    },

    getResquest (params) {
      let url = '/getAnswer'

      get(url, params).then(resp => {
        if (resp.data.code === 0) {
          if (resp.data.data != null) {
            let sucresult = {}
            sucresult.isQa = false
            if (resp.data.data.answer) {
              sucresult.content = resp.data.data.answer.answer
              if (resp.data.data.answer.answer === '') {
                sucresult.content = this.defualWord
                this.addUnknownQA(params)
                this.addunknowLogQA(resp.data.data.answer.questionId)
              } else {
                this.addknowLogQA(resp.data.data.answer.questionId)
              }
              sucresult.questionId = resp.data.data.answer.questionId

              let urlall = '/totalAll'
              let paramsall = {
                quesId: resp.data.data.answer.questionId
              }
              get(urlall, paramsall).then(response => {
              }).catch(response => {
                this.totalPageNum = 0
                this.$notify({
                  title: '提示',
                  message: response.data.data,
                  type: 'warning'
                })
              })
            } else {
              sucresult.content = this.defualWord
              sucresult.questionId = '0'
              this.addUnknownQA(params)
              this.addunknowLogQA('')
            }
            if (resp.data.data.recommend) {
              sucresult.recommended = resp.data.data.recommend
            } else {
              sucresult.recommended = []
            }
            this.QAList.push(sucresult)
            // console.info(this.QAList)
          } else {
            this.addUnknownQA(params)
            this.addunknowLogQA('')

            this.QAList.push(this.result)
          }
          this.chatlog()
          this.question = ''
        }
      }).catch(response => {
        let sucresult = {}
        sucresult.isQa = false
        sucresult.content = this.errorWord
        sucresult.questionId = '0'
        sucresult.recommended = []
        this.QAList.push(sucresult)
        // this.$notify({
        //   title: '提示',
        //   message: '网络异常',
        //   type: 'warning'
        // })
      })
    },
    addknowLogQA (id) {
      let urlall = '/addLogQA'
      let logparams = {
        isUnknowflag: 'know',
        questionId: id,
        siteId: this.siteId
      }
      addQA(urlall, logparams).then(response => {
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '网络异常',
          type: 'warning'
        })
      })
    },
    addunknowLogQA (id) {
      let urlall = '/addLogQA'
      let logparams = {
        isUnknowflag: 'unknow',
        questionId: id,
        siteId: this.siteId
      }
      addQA(urlall, logparams).then(response => {
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '网络异常',
          type: 'warning'
        })
      })
    },
    addUnknownQA (paramsall) {
      let urlall = '/addUnknownQA'
      addQA(urlall, paramsall).then(response => {
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '网络异常',
          type: 'warning'
        })
      })
    },
    handleSelect (item) {
      let question = {
        isQa: true,
        content: item.value,
        recommended: []
      }
      let params = {question: item.value, siteId: this.siteId}
      this.QAList.push(question)
      this.getResquest(params)
      this.question = ''
    },

    querybyQA (item) {
      let msg = document.getElementById('infoDiv')
      msg.scrollTop = msg.scrollHeight
      let question = {
        isQa: true,
        content: item,
        recommended: []
      }
      let params = {question: item, siteId: this.siteId}
      this.QAList.push(question)
      this.getResquest(params)
    }
  }
}
</script>
<style scoped >
.parentdiv{
  pointer-events: none;
}
.praisediv{
  width: 15px;
  height: 15px;
  vertical-align: middle;
  background-image: url("../../assets/common/qadialog/praise.png");
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
}
.pitpraisediv{
  width: 15px;
  height: 15px;
  vertical-align: middle;
  background-image: url("../../assets/common/qadialog/pitpraise.png");
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
  /*pointer-events: none;*/
}
.pitslanderdiv{
  width: 15px;
  height: 15px;
  vertical-align: middle;
  background-image: url("../../assets/common/qadialog/pitslander.png");
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
  /*pointer-events: none;*/
}
.slanderdiv{
  width: 15px;
  height: 15px;
  vertical-align: middle;
  background-image: url("../../assets/common/qadialog/slander.png");
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
}
.blue{
  color: blue;
}
.box-card {
  width: 1190px;
  height: 800px;
  position: absolute;
  /*margin-top: -400px;*/
  border: 0px;
  background-color: rgba(247, 246, 246, 0.9);
}
.card-header {
  display: flex;
  justify-content: space-between;
  background-image: url("~@/assets/common/qadialog/top.png");
  align-items: center;
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
}
.header_word{
  /*font-size: 20px;*/
  /*font-weight: normal;*/
  /*font-stretch: normal;*/
  /*line-height: 60px;*/
  /*letter-spacing: 1px;*/
  /*width: 200px;*/
  text-align: left;
  font-family: PingFang-SC-Heavy;
  font-size: 27px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 70px;
  letter-spacing: 0px;
  color: #ffffff;
  /*margin-left: 3%;*/
}

/deep/ .el-card__body {
  padding: 3px;
}
.title_word{
  float: left;
  padding: 10px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #333333;
}
.answerdiv{
  float: left;
  width: 95%;
  margin: 2%;
}

.questiondiv{a
  float: right;
  width: 95%;
  margin: 2%;
}
.answericon{
  float: left;
  background-image: url("~@/assets/common/qadialog/robothead.png");
  width: 40px;
  height: 40px;
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
}
.questionicon{
  float: right;
  background-image: url("~@/assets/common/qadialog/default.png");
  width: 40px;
  height: 40px;
  background-repeat:no-repeat;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
}
.answerlabel{
  margin: 0% 0.5%;
  float: left;
  width: 85%;
  /*background-color: #cbdff2;*/
  /*border-radius: 4px;*/
}
.questionlabel{
  margin: 0% 0.5%;
  width: 85%;
  float: right;
}
.anlabelword{
  padding: 10px 10px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #333333;
  float: left;
  background-color:rgba(203,223,242, 0.7);
  /*background-color: #cbdff2;*/
  border-radius: 4px;
  text-align: left;
  white-space: normal;
  word-break: break-all;

}
.qulabelword{
  padding: 10px 10px;
  margin: 1%;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #333333;
  float: right;
  background-color:rgba(220,220,220,  0.7);
  /*#dcdcdc*/
  border-radius: 4px;
  text-align: left;
  white-space: normal;
  word-break: break-all;

}
.link-title{
  margin-bottom: 10px;
  width: 90%;
  text-align: left;
  display: inline-block;
  /*display: -webkit-box;*/
  /*-webkit-box-orient: vertical;*/
  /*-webkit-line-clamp: 1;*/
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;

}
/deep/ .el-card__body {
  padding: 0px;

}
</style>
<style>
.el-autocomplete-suggestion {
  margin: 5px 0;
  -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 4px;
  border: 1px solid #E4E7ED;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #FFF;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/services/qadialog.vue